import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule from ".";

export const definition: WidgetDefinition = {
  id: "eis-score",
  module: widgetModule,
  catalog: {
    description: "One Event Integrity Score as a circular gauge, coloured by the EIS ramp.",
    domain: "kpis",
    visual: "KPI",
    purposes: ["live", "reporting"],
    audiences: ["analyst", "client"],
  },
  defaultLayoutClassName: "col-span-12 xl:col-span-3",
};
